import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_kitchen_tabletop: FaireCategoryEntity = {
  token: "cat_home-decor-kitchen-tabletop",
  type: "category",
  name: "Kitchen & tabletop",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/kitchen-tabletop",
  childCategoryTokens: [
    "cat_kitchen-all",
    "cat_kitchen-barware",
    "cat_kitchen-coffee-tea",
    "cat_kitchen-cookware",
    "cat_kitchen-cutlery",
    "cat_kitchen-dinnerware",
    "cat_kitchen-drinkware",
    "cat_kitchen-flatware",
    "cat_kitchen-linens",
    "cat_kitchen-storage",
    "cat_kitchen-tabletop-decor",
    "cat_kitchen-tools",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
